const Logo = (props) => (
  <img
    alt="Logo"
    src="https://assets-pay.hungama.com/assets/un/web/images/logo.svg"
    {...props}
  />
);

export default Logo;
